import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";

// Response Dto
export interface HotelResponseDto extends IEntityWithSoftDeleteDto {
    name: string;
    remarks: string;
    entity: {
        id: string;
        name: string;
    };
}

// Form schema
export const hotelFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: "Name is required" }),
    entityId: z.string().optional(),
    remarks: z.string().optional(),
});

export type HotelFormDto = z.infer<typeof hotelFormSchema>;

